import axios from '../utils/axios';
import { ProviderProducts } from '../@types/reports';

export const fetchProviderProducts = async (): Promise<ProviderProducts[]> => {
  const response = await axios.get<ProviderProducts[]>('/reports/provider-products');
  return response.data;
};
